import { ModalFactory } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n/index';
import Feedback from './index.vue';

export const showFeedback = () => {
  const i18nService = getI18nService();
  const $t = i18nService.t;

  return ModalFactory.create({
    title: $t('yi-jian-fan-kui'),
    content: <Feedback />,
  });
};
